"use client";

/**
 * DiscoverySpotlightsCard 컴포넌트
 * @description 스포트라이트 한 장 — 그림 · 제목 · 글쓴이. 북마크는 두지 않는다. 담는 자리는
 *   글을 열어 본 뒤이지, 훑는 줄 위가 아니다.
 */
import { memo, useCallback } from "react";

import { DISCOVERY_SPOTLIGHT_IMAGE_SIZES } from "./DiscoverySpotlights.styles";
import type { DiscoverySpotlightsCardProps } from "./DiscoverySpotlights.types";

import { trackSpotlightClicked } from "../../analytics";
import { routes } from "@/shared/config/routes";
import {
  AppImage,
  ContentCard,
  IMAGE_PLACEHOLDER,
  Reveal,
  REVEAL_STAGGER,
} from "@/shared/ui";

/** 가장 넓은 격자의 열 수 — 한 줄이 왼쪽부터 차례로 떠오르게 지연을 이 안에서 돌린다 */
const MAX_COLUMNS = 4;

const DiscoverySpotlightsCard = memo<DiscoverySpotlightsCardProps>(
  ({ item, index }) => {
    const track = useCallback(
      () => trackSpotlightClicked(item, index),
      [item, index],
    );
    return (
      <Reveal delay={(index % MAX_COLUMNS) * REVEAL_STAGGER}>
        <ContentCard
          ratio="landscape"
          /* 여러 열이라 자리를 잡는다 — 한 장만 제목이 한 줄이어도 좌우 아래 선이 어긋난다 */
          fixedTextHeight
          title={item.title}
          metadata={item.displayName}
          media={
            <AppImage
              uri={item.thumbnailUrl ?? ""}
              fallback={IMAGE_PLACEHOLDER}
              sizes={DISCOVERY_SPOTLIGHT_IMAGE_SIZES}
            />
          }
          href={routes.blog.detail(item.slug)}
          onClick={track}
        />
      </Reveal>
    );
  },
);

DiscoverySpotlightsCard.displayName = "DiscoverySpotlightsCard";

export default DiscoverySpotlightsCard;
